import {collection, component, EntityData, field, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {StockSizeData} from "../../product-line/product-line.data";

export class ProductLineRecipeIngredientData extends EntityData<ProductLineRecipeIngredientData> {
    @field name: string;
    @field amount: number;
    @component stockSize: StockSizeData;
}

export class ProductLineRecipeCardReportData extends LocalisableEntityData<ProductLineRecipeCardReportData> {
    @field recipeMethod: string;
    @field recipeImage: string;
    @field name: string;
    @collection(ProductLineRecipeIngredientData) ingredients: ProductLineRecipeIngredientData[];
}
